import React, { useContext } from 'react';
import { string, bool } from 'prop-types';
import classNames from 'classnames/bind';
import { Placeholder } from '@thd-olt-component-react/core-ui';
import { StorePodContext } from '../../StorePod.context';
import styles from './store-pod-address.module.scss';

const cx = classNames.bind(styles);

export const StorePodAddress = ({ className, displaySingleLine }) => {
  const { loading, store } = useContext(StorePodContext);
  const {
    city,
    postalCode,
    state,
    street
  } = store?.address || {};

  if (loading) {
    return (
      <div className={cx(className, 'store-pod-address')}>
        <Placeholder height="14px" type="text" />
        {!displaySingleLine && (<Placeholder height="14px" type="text" />)}
      </div>
    );
  }

  return (
    <div className={cx(className, 'store-pod-address')}>
      {!displaySingleLine && (
        <>
          <div className={cx('store-pod-address__text-line')}>{street}</div>
          <div className={cx('store-pod-address__text-line')}>{city}, {state} {postalCode}</div>
        </>
      )}
      {displaySingleLine && (
        <div className={cx('store-pod-address__text-line')}>{street}, {city}, {state} {postalCode}</div>
      )}
    </div>
  );
};

StorePodAddress.propTypes = {
  className: string,
  displaySingleLine: bool
};

StorePodAddress.defaultProps = {
  className: null,
  displaySingleLine: false
};

StorePodAddress.displayName = 'StorePodAddress';
